module.exports = __webpack_public_path__ + "static/img/200043.28998c0b.png";